import React from 'react';
import './style.scss';

const Media = (props) => {
  const { imageUrl, gifUrl, videoUrl } = props;

  return (
    <div className='image-container'>
      {imageUrl && <img className='image' src={imageUrl} alt='customphoto' />}
      {gifUrl && <img src={gifUrl} className='image' alt='option' />}
      {videoUrl && (
        <video src={videoUrl} className='video' alt='option' controls controlsList='nodownload'/>
      )}
    </div>
  );
};

export default Media;
